import {
	fetchFaqFailed,
	fetchFaqSuccess,
	fetchGuidelineFailed,
	fetchGuidelineSuccess,
	fetchHelpPagesFailed,
	fetchTermsFailed,
	fetchTermsSuccess,
} from 'modules/actions';
import {Api, ApiError} from "modules/utils";
import {call, put,} from "typed-redux-saga";


export const fetchFaqSaga = function* () {
	try {
		const response = yield* call(Api.JSON.faq);
		ApiError.CHECK(response);
		yield put(fetchFaqSuccess(response));
	} catch (e: any) {
		yield put(fetchFaqFailed(e));
	}
};

export const fetchGuidelineSaga = function* () {
	try {
		const response = yield* call(Api.JSON.guideline);
		ApiError.CHECK(response);
		yield put(fetchGuidelineSuccess(response));
	} catch (e: any) {
		yield put(fetchGuidelineFailed(e));
	}
};

export const fetchTermsSaga = function* () {
	try {
		const response = yield* call(Api.JSON.terms);
		ApiError.CHECK(response);
		yield put(fetchTermsSuccess(response));
	} catch (e: any) {
		yield put(fetchTermsFailed(e));
	}
};

export const fetchHelpPagesSaga = function* () {
	try {
		yield call(fetchFaqSaga);
		yield call(fetchGuidelineSaga);
		yield call(fetchTermsSaga);
	} catch (e: any) {
		yield put(fetchHelpPagesFailed());
	}
};
